import axios from "axios";

const configHeaders = {
  headers: {
    Authorization: "Bearer " + "yourJWTToken",
  },
};

async function connectApi({ method = "GET", url, payload }) {
  return await axios({
    method,
    url,
    data: payload,
    headers: configHeaders,
    responseType: "json",
  });
}

///////

const baseURL = {
  jwtLogin: "/api/Registration/JWTLogin",
  submitForm: "/api/CRMWorkshop/WorkShopEnrollmentByCampaign_new",
  fetchCourse: "/api/CRMWorkshop/GetWorkShopListByCampaign_new",
  fetchEnquiryHistory: "/api/CRMWorkshop/GetEnrollmentList",
  fetchWorkshopList: "/api/CRMWorkshop/GetWorkShopListById",
  changeWorkshop: "/api/CRMWorkshop/ModifyWorkShopEnrollment",
  cancelWorkshop: "/api/CRMWorkshop/CancelWorkshopEnrollment",
  checkDuplcateSubmission: "/api/CRMWorkshop/CheckDuplcateSubmission",
  getWorkshopInfo: "/api/CRMWorkshop/GetWorkshopInfo",
};
///////

export async function jwtLogin(payload) {
  const config = {
    method: "POST",
    url: baseURL.jwtLogin,
    payload,
  };
  return await connectApi(config);
}

export async function submitForm(payload) {
  const config = {
    method: "POST",
    url: baseURL.submitForm,
    payload,
  };
  return await connectApi(config);
}

export async function fetchCourse({
  lang = "",
  code = "",
  sua_id = "",
  token = "",
  workshop_code = "",
}) {
  const config = {
    method: "GET",
    url:
      baseURL.fetchCourse +
      `?lang=${lang}&code=${code}&sua_id=${sua_id}&token=${token}&workshop_code=${workshop_code}`,
  };
  return await connectApi(config);
}

export async function fetchEnquiryHistory({
  lang = "",
  email = "",
  phone = "",
  sua_id = "",
  token = "",
}) {
  const config = {
    method: "GET",
    url:
      baseURL.fetchEnquiryHistory +
      `?lang=${lang}&email=${email}&phone=${phone}&sua_id=${sua_id}&token=${token}`,
  };
  return await connectApi(config);
}

export async function changeWorkshop(payload) {
  const config = {
    method: "POST",
    url: baseURL.changeWorkshop,
    payload,
  };
  return await connectApi(config);
}

export async function fetchWorkshopList({
  lang = "",
  workshop_detail_id = "",
}) {
  const config = {
    method: "GET",
    url:
      baseURL.fetchWorkshopList +
      `?lang=${lang}&workshop_detail_id=${workshop_detail_id}`,
  };
  return await connectApi(config);
}

export async function cancelWorkshop(payload) {
  const config = {
    method: "POST",
    url: baseURL.cancelWorkshop,
    payload,
  };
  return await connectApi(config);
}

export async function checkDuplcateSubmission({
  email = "",
  phone = "",
  workshop_detail_id = "",
  lang = "",
}) {
  const config = {
    method: "GET",
    url:
      baseURL.checkDuplcateSubmission +
      `?lang=${lang}&email=${email}&phone=${phone}&workshop_detail_id=${workshop_detail_id}`,
  };
  return await connectApi(config);
}

export async function getWorkshopInfo({ code = "" }) {
  const config = {
    method: "GET",
    url: baseURL.getWorkshopInfo + `?code=${code}`,
  };
  return await connectApi(config);
}
